import instance from "../root.api";

export const getCurrentChurchRequest = () =>
  instance
    .get("/churches/me")
    .then(response => ({ response }))
    .catch(response => ({ ...response }));
